import { render, staticRenderFns } from "./XhPageTable.vue?vue&type=template&id=6834a8ac&scoped=true&"
import script from "./XhPageTable.vue?vue&type=script&lang=js&"
export * from "./XhPageTable.vue?vue&type=script&lang=js&"
import style0 from "./XhPageTable.vue?vue&type=style&index=0&id=6834a8ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834a8ac",
  null
  
)

export default component.exports